import { render, staticRenderFns } from "./Resizer.vue?vue&type=template&id=2c40efe4&scoped=true&"
import script from "./Resizer.vue?vue&type=script&lang=js&"
export * from "./Resizer.vue?vue&type=script&lang=js&"
import style0 from "./Resizer.vue?vue&type=style&index=0&id=2c40efe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c40efe4",
  null
  
)

export default component.exports